import { LinkProps, Link as MuiLink } from '@mui/material';
import { Link as ReactRouterLink } from 'react-router';

import { FC } from 'react';

export const Link: FC<LinkProps & { to: string }> = (props) => {
  return <MuiLink {...props} component={ReactRouterLink} to={props.to} />;
};
